import { useIntl } from 'react-intl'
import { loyaltyUnitMessages } from 'constants/config/i18nMessages'

interface Props {
  points: number
  abbreviated?: boolean
}

/**
 * Formats a loyalty points count with the correct plural unit label.
 *
 * @example
 * <FormatLoyaltyPoints points={5} />               // "5 points"
 * <FormatLoyaltyPoints points={1} />               // "1 point"
 * <FormatLoyaltyPoints points={5} abbreviated />   // "5 pts"
 */
function FormatLoyaltyPoints({ points, abbreviated }: Props) {
  const intl = useIntl()
  const message = abbreviated ? loyaltyUnitMessages.pointsAbbreviationCount : loyaltyUnitMessages.pointsCount
  return <>{intl.formatMessage(message, { count: points })}</>
}

export default FormatLoyaltyPoints
